<template>
  <div id="unOutManage">
        <el-form ref="searchForm" style="width:100%" :inline="true" :model="searchForm" :label-position="labelPosition">
            <el-form-item style="margin-bottom:15px"  class="hewidth">
                <el-select v-model="searchForm.status" placeholder="请选择出库状态" clearable>
                    <el-option v-for="(item,index) in pickingStatusList" 
                        :label="item.paraName" 
                        :value="item.paraCode" 
                        :key="index">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item style="margin-bottom:15px"  class="hewidth">
                <el-input clearable v-model.trim="searchForm.qrCode" placeholder="请输入二维码编号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px"  class="hewidth">
                <el-input clearable v-model.trim="searchForm.orderSn" placeholder="请输关联订单号"></el-input>
            </el-form-item>
            <el-form-item style="margin-bottom:15px" class="hewidth">
                <el-input clearable v-model.trim="searchForm.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item style="width: 40% margin-bottom: 15px;">
                <el-button type="primary" size="medium" @click="onSubmit('searchForm')">查询</el-button>
                <el-button type="text" @click="clearFrom()" style="width: 60px;color: #169BD5;">重置</el-button>
                <el-button type="success" size="medium" @click="downLoad.exportExcel('tableId')">导出</el-button>
                    <el-button type="success" size="medium" @click="exportWarehouse">批量出库</el-button>
                   <!--  <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;margin-left: 30px;" @click="refresh()"></i> -->
            </el-form-item>
           <!--  <el-form-item class="fr">
               <el-col style="text-align:right">
                   
               </el-col>
           </el-form-item> -->
        </el-form>
        <el-col>
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    id="tableId"
                    :data="returnData"
                    border
                    ref="multipleTable"
                    @row-click="handleCurrentChange1"
                    @selection-change="handleSelectionChange"
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55">
                    </el-table-column>
                    <el-table-column
                        prop="orderSn"
                        align="center"
                        width="200"                      
                        label="订单编号">
                    </el-table-column>
                     <el-table-column
                        align="center"
                        prop="engineerName"
                        width="150"
                        label="门店工程师">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        width="150"
                        label="手机号码">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="qrCode"
                        width="100"
                        label="二维码">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="200"
                        label="故障">
                        <template slot-scope="scope">
                            <span style="display:block" v-for="(item,index) in scope.row.faultSubclass" :key="index">{{item.faultSubclassName}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="modelName"
                        align="center"
                        width="150"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        prop="colorName"
                        align="center"
                        label="颜色">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="remark"
                        label="备注">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="refundReason"
                        label="操作" v-if="basicsAuth.ensure" > 
                        <template slot-scope="scope">
                            <span class="active-status" v-if="scope.row.status == '1'" @click="newModel(scope.row)">出库</span>
                            <span v-else>已出库</span>                            
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50,100,1000]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
        <el-dialog title="提示" width="400px" :visible.sync="dialogFormVisible" >
            <el-form :model="modelForm" :label-position="labelPosition">
                <el-form-item label="门店工程师" label-width="100px">
                    <el-select
                        @change="changeMaintenancePerson"
                        clearable
                        v-model="modelForm.maintenancePerson"
                        :disabled="isDisabled"
                        filterable
                        :filter-method="PinyinMatch"
                        placeholder="门店工程师">
                        <el-option
                            v-for="item,index in engineerDataList"
                            :key="index"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" v-if="!isExport" @click="confirmBtn(0)">确 定</el-button>
                <el-button type="primary" v-else  @click="confirmBtn(1)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import PinyinMatch from 'pinyin-match';
    import { shopInventoryList,confirmEnsure,engineerList,exportEnsureBatch } from "../../../api/api";
    import {getPermission} from '../../../api/authRequest'
    export default {
        name: 'unOutManage',
        data () {
            return {
                dialogFormVisible:false,
                maintenancePerson:'',
                labelPosition:'left',
                isDisabled:false,
                pickingStatusList:[
                    {
                        paraName:'待确认',
                        paraCode:'1'
                    },
                    {
                        paraName:'已确认',
                        paraCode:'2'
                    }
                ],
                pickingRepairStatus:[
                    {
                        paraName:'维修完成',
                        paraCode:'1'
                    },
                    {
                        paraName:'维修失败',
                        paraCode:'2'
                    },
                ],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                searchForm:{
                    type:"2",
                    qrCode:'',  //二维码编号
                    status:'',  //入库状态
                    orderSn:'',  //关联订单号
                    phone:''
                },
                modelForm:{
                    id:'',
                    orderId:'',
                    maintenancePerson:''
                },
                returnData: [],
                multipleSelection:[],
                engineerDataList:[],
                copy:[],
                isExport:false,
                basicsAuth:{
                    ensure:false
                }
            }
        },
        created(){
            this.basicsAuth.ensure = getPermission('/api/shopInventory/ensure');
            this.getEngineerList();
            this.getShopInventoryList();
        },
        methods: {
            handleCurrentChange1(row, event, column){
                let isHave = false;
                this.multipleSelection.forEach((item,index)=>{
                    if(row.orderSn === item.orderSn){
                        isHave = true
                    }
                })
                isHave ? this.$refs.multipleTable.toggleRowSelection(row,false) : this.$refs.multipleTable.toggleRowSelection(row,true);
            },
            //获取选中型号的物料数据 => 数组
            handleSelectionChange(val) {
                if(val != []){
                    this.multipleSelection = val;
                }
            },
            closeDialog(){
                this.dialogFormVisible = false;
                this.isExport = false;
            },
            exportWarehouse(){
                if(this.multipleSelection.length == 0){
                    this.$message({
                        message: '还未选择订单，请选择订单',
                        type: "warning"
                    });
                    return;
                }
                this.isExport = true;
                this.dialogFormVisible = true;
            },
            //强制刷新
            changeMaintenancePerson(e){
                console.log(e);
                this.modelForm.maintenancePerson = e;
                this.$forceUpdate();
            },
            PinyinMatch(val){
                if(val && val.length > 0){
                    let result = [];
                    this.copy.forEach(i => {
                        let m = PinyinMatch.match(i.name,val);
                        if(m) {
                            result.push(i);
                        }
                    })
                    this.modelForm.maintenancePerson = val;
                    this.engineerDataList = result;
                }else{
                    this.engineerDataList = this.copy;
                    this.modelForm.maintenancePerson = "";
                }
            },
            newModel(row){
                this.modelForm.id = row.id;
                this.modelForm.orderId = row.orderId;
                if(row.maintenancePerson){
                    this.isDisabled = true;
                    this.modelForm.maintenancePerson = row.maintenancePerson;
                }else{
                    this.isDisabled = false;
                }
                this.dialogFormVisible = true;
            },
            confirmBtn(type){                
                if(!this.modelForm.maintenancePerson){
                    this.$message({
                        message: '请选择门店工程师',
                        type: "warning"
                    });
                    return;
                }
                type === 0 ? this.submitConfirmModel(0) : this.submitConfirmModel(1);
            },
            //获取门店工程师列表
            getEngineerList(){
                let params = {
                    startRow:1,
                    pageSize:10000,
                    type:'MD',
                    state: 1
                }
                engineerList(params).then(res =>{
                    if(res.data.status == '100'){
                        this.engineerDataList = res.data.results.list;
                        this.copy = Object.assign(this.engineerDataList); //保留数据源
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //确认收到
            submitConfirmModel(type){
                let para;
                let request;
                let arr = [];
                this.multipleSelection.forEach((item,index)=>{
                    arr.push({
                        id:item.id,
                        orderId:item.orderId,
                        maintenancePerson:this.modelForm.maintenancePerson
                    })
                })
                if(type == 0){
                    para = this.modelForm;
                    request = confirmEnsure;
                }else{
                    para = arr;
                    request = exportEnsureBatch;
                }
                request(para).then(res => {
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.5)'
                    });
                    if (res.data.status==100) {
                        this.$message({
                            message: '提交成功',
                            type: "success"
                        });
                        /*刷新*/
                        this.dialogFormVisible = false;
                        this.modelForm = {};
                        this.getShopInventoryList();
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                    loading.close();
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //重置
            clearFrom(){
                Object.keys(this.searchForm).forEach(key => this.searchForm[key]= '');
                this.searchForm.type="2";
                this.getShopInventoryList();
            },
            //获取退款申请管理列表
            getShopInventoryList(){
                this.searchForm.startRow = this.pages.page;
                this.searchForm.pageSize = this.pages.pageSize;
                shopInventoryList(this.searchForm).then(res => {          
                    if (res.data.status==100) {            
                            this.returnData = res.data.results.list
                            this.pages.total = res.data.results.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getShopInventoryList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getShopInventoryList()
            },
            //刷新
            refresh() {
                this.clearFrom();
            },
            //检索取机记录
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        this.getShopInventoryList()
                    } else {
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    .hide-upload{
        .el-upload {
            display: none;
        }
    } 
    #unOutManage{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
        .active-status{
            color:#409EFF;
            cursor:pointer
        }
        .avatar {
            width: 178px;
            height: 178px;
            display: inline-block;
        }
        .yuan{
            position:relative;
            &:after{
                position:absolute;
                right:0;
                content:'元';
                font-size:14px;
                color:#666;
                line-height:40px;
                width:30px;
                height:40px;
                top:0;
                display:block
            }
        }
    }
.hewidth {
        width: 10% !important;
      }
</style>



// WEBPACK FOOTER //
// unOutManage.vue?6b55cc87